export default {
    section: 'Retention of Expenses',
    name: 'offer-letter-retention-expenses',
    items: [
        {
            type: 'radio-list',
            text: 'Retention of Employee(s)',
            name: 'offer-letter-retention-employee',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'textarea',
                    text: 'Names of Employee(s) Retained',
                    name: 'offer-letter-retention-employee-names',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-employee',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Employee Retention Timeframe',
                    props: {},
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-retention-employee-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-retention-employee-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-employee',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Employee Salary',
                    name: 'offer-letter-retention-employee-salary',
                    props: {
                        items: [
                            {
                                text: 'Current Salary + Benefits',
                                value: 'salary-benefits'
                            },
                            {
                                text: 'Current Salary + Benefits + Annual Raise Increases',
                                value: 'salary-benefits-increases'
                            },
                            {
                                text: 'Other',
                                value: 'other'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-employee',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Please describe employee salary',
                    name: 'offer-letter-retention-employee-salary-description',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-employee',
                                value: 'yes'
                            },
                            {
                                name: 'offer-letter-retention-employee-salary',
                                value: 'other'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Retain Office',
            name: 'offer-letter-retention-office',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'radio-list',
                    text: 'Lease or Buy?',
                    name: 'offer-letter-retention-office-lease-buy',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Lease',
                                value: 'lease'
                            },
                            {
                                text: 'Buy',
                                value: 'buy'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-office',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Lease Timeframe',
                    props: {},
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-retention-office-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-retention-office-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-office',
                                value: 'yes'
                            },
                            {
                                name: 'offer-letter-retention-office-lease-buy',
                                value: 'lease'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Amount of Lease',
                    name: 'offer-letter-retention-office-amount',
                    width: 3,
                    props: {
                        label: 'Amount of Lease',
                        format: 'dollars'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-office',
                                value: 'yes'
                            },
                            {
                                name: 'offer-letter-retention-office-lease-buy',
                                value: 'lease'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Address',
                    name: 'offer-letter-retention-office-address-street',
                    props: {
                        label: 'Address'
                    },
                    subItems: [
                        {
                            type: 'inline',
                            text: ' ',
                            items: [
                                {
                                    type: 'text-field',
                                    name: 'offer-letter-retention-office-address-city',
                                    width: 3,
                                    props: {
                                        label: 'City'
                                    }
                                },
                                {
                                    type: 'selectlist',
                                    name: 'offer-letter-retention-office-address-state',
                                    width: 1,
                                    props: {
                                        label: 'State',
                                        items: [
                                            // TODO: Swap States
                                            {
                                                text: 'swap-states',
                                                value: 'swap-states'
                                            }
                                        ]
                                    }
                                },
                                {
                                    type: 'text-field',
                                    name: 'offer-letter-retention-office-address-zip',
                                    width: 2,
                                    props: {
                                        label: 'Zip'
                                    }
                                }
                            ]
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-office',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Notes',
                    name: 'offer-letter-retention-office-notes',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-office',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Pay for Seller\'s Licensing/Franchise Fees/Other Fees',
            name: 'offer-letter-retention-fees',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'inline',
                    text: 'Timeframe',
                    props: {},
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-retention-fees-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-retention-fees-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-fees',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Please specify',
                    name: 'offer-letter-retention-fees-description',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-retention-fees',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/retention-expenses.js